'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryViewerContainer = exports.mapDispatchToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // GalleryViewerContainer

// if bindActionCreators is needed, uncomment this line
// import {bindActionCreators} from 'redux';

// components

// action creators


exports.mapStateToProps = mapStateToProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Modal = require('../components/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _GalleryViewer = require('../components/GalleryViewer');

var _GalleryViewer2 = _interopRequireDefault(_GalleryViewer);

var _galleryViewer = require('../modules/galleryViewer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mapStateToprops can be either an object or a funciton
function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    items: state.galleryViewer.media,
    isOpen: state.galleryViewer.isGalleryOpen,
    activeIndex: state.galleryViewer.activeIndex
  };
}

// mapDispatchToprops can be either an object or a funciton
var mapDispatchToProps = exports.mapDispatchToProps = { closeGalleryViewer: _galleryViewer.close, setActiveIndex: _galleryViewer.setActiveIndex };

var GalleryViewerContainer = exports.GalleryViewerContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GalleryViewerContainer, _Component);

  function GalleryViewerContainer() {
    (0, _classCallCheck3.default)(this, GalleryViewerContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GalleryViewerContainer.__proto__ || (0, _getPrototypeOf2.default)(GalleryViewerContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GalleryViewerContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          i18n = _props.i18n,
          items = _props.items,
          isOpen = _props.isOpen,
          closeGalleryViewer = _props.closeGalleryViewer,
          setActiveIndex = _props.setActiveIndex,
          activeIndex = _props.activeIndex;


      return _react2.default.createElement(
        _Modal2.default,
        { isOpen: isOpen, style: { overlay: { zIndex: 1064 } } },
        _react2.default.createElement(_GalleryViewer2.default, { i18n: i18n, items: items, onRequestClose: closeGalleryViewer, setActiveIndex: setActiveIndex, activeIndex: activeIndex })
      );
    }
  }]);
  return GalleryViewerContainer;
}(_react.Component), _class.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired,
  isOpen: _react.PropTypes.bool,
  // functions
  closeGalleryViewer: _react.PropTypes.func.isRequired,
  setActiveIndex: _react.PropTypes.func.isRequired,
  activeIndex: _react.PropTypes.number.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GalleryViewerContainer);


//////////////////
// WEBPACK FOOTER
// ./src/containers/GalleryViewerContainer.js
// module id = 1235
// module chunks = 0